import SimpleTextComponent from "@baseUI/component/text/SimpleTextComponent";

export default class Watches extends SimpleTextComponent {

    constructor(style) {
        super(style)
        this.showTime()
    }

    showTime = () => {
        const date = new Date()
        let h = date.getHours() // 0 - 23
        let m = date.getMinutes() // 0 - 59
        let s = date.getSeconds() // 0 - 59
        let session = "AM"

        if(h === 0){
            h = 12
        }

        /*if(h > 12){
            h = h - 12
            session = "PM"
        }*/

        h = (h < 10) ? "0" + h : h
        m = (m < 10) ? "0" + m : m
        s = (s < 10) ? "0" + s : s

        const time = h + ":" + m + ":" + s
        this.text = time

        setTimeout(this.showTime.bind(this), 1000)

    }
}
